import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ONX-Logo_VF_RGB.png")